import Head from "next/head";
import Breadcrumb from "@/components/BreadCrumb";
import Layout from "@/components/layout";

export default function Disclaimer() {
  return (
    <Layout>
      <Head>
        <title>Disclaimer | Tradewise</title>
        <meta
          name="description"
          content="Review Tradewise's disclaimer to understand how we protect your data. Learn about our data usage, security measures, and your privacy rights with us."
        />
      </Head>
      <section>
        <Breadcrumb classNames="absolute top-20 left-4 lg:left-20" />
        <div className="container prose my-10 max-md:mt-12">
          <h1>Disclaimer</h1>
          <p>
            The courses offered through Tradewise are strictly for educational purposes and do not constitute financial or investment advice. We do not guarantee any profits, trading success, or specific outcomes. All trading involves risk, and decisions made based on course content are solely at the discretion and risk of the participant.
            Tradewise, its instructors, and partners are not SEBI-registered advisors, and no course material should be considered a recommendation for any investment or trading activity. Sample code, strategies, and examples provided are for learning only and do not ensure future performance.
            By enrolling, you agree that Tradewise is not liable for any trading losses, technical issues, or outcomes resulting from course participation. All course fees are non-refundable once the course begins, and course materials are protected intellectual property, not to be copied or redistributed without written consent.
          </p>

        </div>
      </section>
    </Layout>
  );
}
